import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcVolumeoffFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.11a1 1 0 0 1 .677.264l4.661 4.288c.641.59 1.677.134 1.677-.736V4.162c0-.872-1.039-1.327-1.679-.735L6.787 7.734A1 1 0 0 1 6.11 8zM21.859 9.349a.75.75 0 0 1 0 1.06l-1.767 1.767 1.769 1.769a.75.75 0 0 1-1.06 1.06l-1.77-1.768-1.769 1.769a.75.75 0 0 1-1.06-1.061l1.769-1.769-1.767-1.767a.75.75 0 0 1 1.06-1.06l1.767 1.766 1.767-1.766a.75.75 0 0 1 1.06 0"
  }));
}
var IcVolumeoffFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVolumeoffFill));

export { IcVolumeoffFill as I };
